import React, { useContext, useState } from "react";
import footerstyles from "./footer.module.css";
import { LanguageContext } from "../../context/LanguageContext";
import { HashLink } from "react-router-hash-link";

function Footer() {
  const { data } = useContext(LanguageContext);

  const [showTooltip, setShowTooltip] = useState("");
  const [showMetaTooltip, setShowMetaTooltip] = useState("");

  const footer = data.footer;

  const showTip = () => {
    setShowTooltip(!showTooltip);
  };

  const showMetaTip = () => {
    setShowMetaTooltip(!showMetaTooltip);
  };

  return (
    <div className="mainWrap">
      <div className={footerstyles.contactUs}>
        <h2 className="mainHeading">{footer.title}</h2>
        <p className="subHeading">{footer.subtitle}</p>
      </div>

      <div className={footerstyles.footerContentWrap}>
        <div className={footerstyles.footerLogo}>
          <img src="/assets/images/homepage/logo_large.png" alt="logo" />
        </div>

        <div className={footerstyles.footerCotactdetails}>
          <div className={footerstyles.footerLocation}>
            <img src="/assets/images/homepage/location.png" alt="logo" />
            <a href="https://www.google.com/maps/search/119285,+Russia,+Moscow,+Vorobievskoe+shosse,+6,+Business+Center+ground+floor,+office+22/@55.7064945,37.5162698,17z/data=!3m1!4b1">
              {" "}
              <p>Moscow Office</p>
              <p>
                142001, Russia, Moscow Region, Domodedovo, st. 1-ya
                Kommunisticheskaya (Severnyy mkr.) stroyenie 34a, 1st floor,
                office 1
              </p>
            </a>
          </div>
          <div className={footerstyles.footermail}>
            <img src="/assets/images/homepage/Message.png" alt="logo" />
            <a href="mailto:sales@ltd-easytrading.com">
              sales@ltd-easytrading.com
            </a>
          </div>
          <div className={footerstyles.footerPhone}>
            <img src="/assets/images/homepage/Call.png" alt="logo" />
            <a href="tel:8 495 602 01 79">{footer.phone}</a>
          </div>
          <div className={footerstyles.seperator} />
          <div className={footerstyles.footerLocation}>
            <img src="/assets/images/homepage/location.png" alt="logo" />
            <a href="https://www.google.com/maps/search/353900,+Novorossiysk,+Engelsa+7,+office+402/@44.7079502,37.7215987,13z/data=!3m1!4b1">
              {" "}
              <p>Novorossiysk Office</p>
              <p>353900, Novorossiysk, Engelsa 7, office 402</p>
            </a>
          </div>
          <div className={footerstyles.footermail}>
            <img src="/assets/images/homepage/Message.png" alt="logo" />
            <a href="mailto:logistics@ltd-easytrading.com">
              logistics@ltd-easytrading.com
            </a>
          </div>
          <div className={footerstyles.footerPhone}>
            <img src="/assets/images/homepage/Call.png" alt="logo" />
            <a href="tel:8 495 602 01 79">{footer.phone}</a>
          </div>
          <div className={footerstyles.footerLocation} style={{marginTop: 20}}>
            <img src="/assets/images/homepage/location.png" alt="logo" />
            <a href="https://www.google.com/maps/search/353900,+Novorossiysk,+Engelsa+7,+office+402/@44.7079502,37.7215987,13z/data=!3m1!4b1">
              {" "}
              <p>Saint Petersburg Office</p>
              <p>
                198095, Saint Petersburg, Saint. Marshala Govorova, 35, Liter A,
                4th floor, office 404
              </p>
            </a>
          </div>
          <div className={footerstyles.footermail}>
            <img src="/assets/images/homepage/Message.png" alt="logo" />
            <a href="mailto:logistics@ltd-easytrading.com">
              logistics@ltd-easytrading.com
            </a>
          </div>
        </div>

        {footer.links &&
          footer.links.length > 0 &&
          footer.links.map((item, i) => (
            <div className={footerstyles.footerLinksWrapper}>
              <div className={footerstyles.footerSocialLinksWrap}>
                <h5>{footer.follow}</h5>

                <div className={footerstyles.footerSocialLinks}>
                  <div
                    className={footerstyles.footerSocialInsta}
                    onMouseEnter={showTip}
                    onMouseLeave={showTip}
                  >
                    <img
                      src="/assets/images/homepage/instagram.png"
                      alt="instagram"
                    />
                  </div>

                  {showTooltip ? (
                    <div className={footerstyles.instatooltip}>
                      <p>Coming Soon</p>
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    className={footerstyles.footerSocialInsta}
                    onMouseEnter={showMetaTip}
                    onMouseLeave={showMetaTip}
                  >
                    <img src="/assets/images/homepage/meta.png" alt="meta" />
                  </div>

                  {showMetaTooltip ? (
                    <div className={footerstyles.instatooltip}>
                      <p>Coming Soon</p>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className={footerstyles.footerSocialInsta}>
                    <a
                      href="https://www.youtube.com/channel/UCjRHIP-JvMytnxgMo49sCGQ"
                      target="-blank"
                      rel="noreferer"
                    >
                      <img
                        src="/assets/images/homepage/youtube.png"
                        alt="youtube"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className={footerstyles.footerNavigationWrap} key={i}>
                <div className={footerstyles.footerNavigation}>
                  <h5>
                    <HashLink smooth to="/#top">
                      {item.home}
                    </HashLink>
                  </h5>
                  <h5>
                    <HashLink smooth to="/#AboutUs">
                      {item.aboutus}
                    </HashLink>
                  </h5>
                  <h5>
                    <HashLink smooth to="/#whyus">
                      {item.whyus}{" "}
                    </HashLink>
                  </h5>
                  <h5>
                    <HashLink smooth to="/ourProducts#top">
                      {item.products}
                    </HashLink>
                  </h5>
                </div>

                <div className={footerstyles.footerNavigation}>
                  <h5>
                    <HashLink smooth to="/#OurTeam">
                      {item.ourteam}
                    </HashLink>
                  </h5>
                  <h5>
                    <HashLink smooth to="/careers#top">
                      {item.careers}
                    </HashLink>
                  </h5>
                  <h5>
                    <HashLink smooth to="/supplier#top">
                      {item.becomeaSupplier}
                    </HashLink>
                  </h5>
                  <h5>
                    <HashLink smooth to="/contact#top">
                      {item.contactus}
                    </HashLink>
                  </h5>
                </div>
              </div>
            </div>
          ))}
      </div>

      <p className={footerstyles.footerCopy}>&copy; {footer.copyright}</p>
    </div>
  );
}

export default Footer;
